const accessRoute = {
  HOME: {
    path: "/admin/home",
  },
};
export default accessRoute;
